import Vue from 'vue'
import iView from 'iview'
import Router from 'vue-router'
import { getUserId, getToken } from '@/libs/util'
import config from '@/config'
Vue.use(Router)


//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/home",
    name: "Home",
    meta: {
      title: "首页"
    },
    component: ()=>import("@/mainhtml/commen_home.vue"),
   /* component: () =>
        import(/!* webpackChunkName: "login" *!/ "views/Home.vue")*/
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "about" */ '../views/test.vue')
  },
  {
    path: '/home/index',
    name: 'Index5',
    component: ()=>import("@/mainhtml/shouye.vue")
  },
  {
    path: '/eletest',
    name: 'eletest',
    component: () => import(/* webpackChunkName: "about" */ '../views/eletest.vue')
  },
  {
    path: '/editor',
    name: 'editor',
    component: () => import(/* webpackChunkName: "about" */ '../mainhtml/editor.vue')
  },
  {
    path: '/whzcfg',
    name: 'editor',
    component: () => import(/* webpackChunkName: "about" */ '../mainhtml/whzcfg.vue')
  },
  {
    path: '/getecharts',
    name: 'editor',
    component: () => import(/* webpackChunkName: "about" */ '../mainhtml/spf_echats.vue')
  },
  /*{
    path: "/ywhome/index",
    name: "Index5",
    component: ()=>import("@/mainhtml/shouye_main.vue")
  },*/
  {
      path: "/ywhome/clfhome/ClfopenJjrxx",
      name: "ClfopenJjrxx",
      component: ()=>import("@/mainhtml/clf/ClfopenJjrxx.vue")
  },
  {
    path: "/ywhome/clfhome/openClfxxByEWM",
    name: "openClfxxByEWM",
    component: ()=>import("@/mainhtml/clf/openClfxxByEWM.vue")
  },
  {
    path: "/ywhome",
    component: ()=>import("@/mainhtml/commen_home.vue"),
    redirect: "/ywhome/spfhome",
    children: [
      {
        path: "/ywhome/spfhome",
        name: "spfhome",
        component: ()=>import("@/mainhtml/spf_home.vue")
      },
      {
        path: "/ywhome/clfhome",
        name: "Index2",
        component: ()=>import("@/mainhtml/clf_home.vue")
      },
      {
        path: "/ywhome/jjglhome",
        name: "Index4",
        component: ()=>import("@/mainhtml/jjgl_home.vue")
      },
      {
        path: "/ywhome/bgxzhome",
        name: "Index3",
        component: ()=>import("@/mainhtml/bgxz_home.vue")
      },
      {
        path: "/ywhome/bgxzXxjm",
        name: "bgxzXxjm",
        component: ()=>import("@/mainhtml/bgxzXxjm.vue")
      },
      {
        path: "/ywhome/zcfghome",
        name: "Index5",
        component: ()=>import("@/mainhtml/zcfg_home.vue")
      },
      {
        path: "/ywhome/zcfgXxjm",
        name: "zcfgXxjm",
        component: ()=>import("@/mainhtml/zcfgXxjm.vue")
      },
      {
        path: "/ywhome/xwXxjm",
        name: "xwXxjm",
        component: ()=>import("@/mainhtml/xwXxjm.vue")
      },
      {
        path: "/ywhome/xxcxhome",
        name: "Index5",
        component: ()=>import("@/mainhtml/xxcx_home.vue")
      },
      {
        path: "/ywhome/qfhtcx",
        name: "Index5",
        component: ()=>import("@/mainhtml/xxcx/qfhtcx.vue")
      },
      {
        path: "/ywhome/xfhtcx",
        name: "Index5",
        component: ()=>import("@/mainhtml/xxcx/xfhtcx.vue")
      },
      {
        path: "/ywhome/clfhtcx",
        name: "Index5",
        component: ()=>import("@/mainhtml/xxcx/clfhtcx.vue")
      },
      {
        path: "/ywhome/jjjgcx",
        name: "Index5",
        component: ()=>import("@/mainhtml/xxcx/jjjgcx.vue")
      },
      {
        path: "/ywhome/jdcx",
        name: "Index5",
        component: ()=>import("@/mainhtml/xxcx/jdcx.vue")
      },
      {
        path: "/ywhome/zjcyrycx",
        name: "zjcyrycx",
        component: ()=>import("@/mainhtml/xxcx/zjcyrycx.vue")
      },
      {
        path: "/ywhome/spfhome/ysxkshowmore",
        name: "ysxkshowmore",
        component: ()=>import("@/mainhtml/ysxk_showmore.vue")
      },
      {
        path: "/ywhome/spfhome/xsbashowmore",
        name: "xsbashowmore",
        component: ()=>import("@/mainhtml/xsba_showmore.vue")
      },
      {
        path: "/ywhome/spfhome/ysxkshowmoreXx",
        name: "ysxkshowmoreXx",
        component: ()=>import("@/mainhtml/ysxkshowmoreXx.vue")
      },
      {
        path: "/ywhome/spfhome/xsbashowmoreXx",
        name: "xsbashowmoreXx",
        component: ()=>import("@/mainhtml/xsbashowmoreXx.vue")
      },
      {
        path: "/ywhome/spfhome/lpbXx",
        name: "lpbXx",
        component: ()=>import("@/mainhtml/lpbxx.vue")
      },
      {
        path: "/ywhome/spfhome/SearchXmxx",
        name: "lpbXx",
        component: ()=>import("@/mainhtml/SearchXmxx.vue")
      },
      {
        path: "/ywhome/clfhome/openClfxx",
        name: "openClfxx",
        component: ()=>import("@/mainhtml/clf/openClfxx.vue")
      },
      {
        path: "/ywhome/jjgl/jjjggs",
        component: ()=>import("@/mainhtml/commen_jjgl.vue"),
        redirect: "/ywhome/jjgl/jjjggs",
        children: [
          {
            path: "/ywhome/jjgl/jjjggs",
            name: "jjjggs",
            component: ()=>import("@/mainhtml/jjgl/jjjggs.vue")
          },
          {
            path: "/ywhome/jjgl/jjjggs_cx",
            name: "jjjggs_cx",
            component: ()=>import("@/mainhtml/jjgl/jjjggs_cx.vue")
          },
          {
            path: "/ywhome/jjgl/zlqygs",
            name: "zlqygs",
            component: ()=>import("@/mainhtml/jjgl/zlqygs.vue")
          },
          {
            path: "/ywhome/jjgl/zlqygs_cx",
            name: "zlqygs_cx",
            component: ()=>import("@/mainhtml/jjgl/zlqygs_cx.vue")
          },
          {
            path: "/ywhome/jjgl/qycyrygs",
            name: "qycyrygs",
            component: ()=>import("@/mainhtml/jjgl/qycyrygs.vue")
          },
          {
            path: "/ywhome/jjgl/qycyrygs_cx",
            name: "qycyrygs_cx",
            component: ()=>import("@/mainhtml/jjgl/qycyrygs_cx.vue")
          },
          {
            path: "/ywhome/jjgl/jypjgs",
            name: "jypjgs",
            component: ()=>import("@/mainhtml/jjgl/jypjgs.vue")
          },
          {
            path: "/ywhome/jjgl/jypjgs_cx",
            name: "jypjgs_cx",
            component: ()=>import("@/mainhtml/jjgl/jypjgs_cx.vue")
          },
          {
            path: "/ywhome/jjgl/xyphb",
            name: "xyphb",
            component: ()=>import("@/mainhtml/jjgl/xyphb.vue")
          },
          {
            path: "/ywhome/jjgl/xyphb_cx",
            name: "xyphb_cx",
            component: ()=>import("@/mainhtml/jjgl/xyphb_cx.vue")
          },
          {
            path: "/ywhome/jjgl/xyxjgs",
            name: "xyxjgs",
            component: ()=>import("@/mainhtml/jjgl/xyxjgs.vue")
          },
          {
            path: "/ywhome/jjgl/xyda",
            name: "xyda",
            component: ()=>import("@/mainhtml/jjgl/xyda.vue")
          },
          {
            path: "/ywhome/jjgl/xyda_cx",
            name: "xyda_cx",
            component: ()=>import("@/mainhtml/jjgl/xyda_cx.vue")
          },
          {
            path: "/ywhome/jjgl/jyphb",
            name: "xyda",
            component: ()=>import("@/mainhtml/jjgl/jyphb.vue")
          },
        ]
      },
    ]
  },
  {
    path: "/houtai",
    name:"houtai",
    component: ()=>import("@/mainhtml/houtai/commen_houtai.vue"),
    redirect: "/houtai/zcfg",
    children: [
      {
        path: "/houtai/zcfg",
        name: "zcfg",
        component: ()=>import("@/mainhtml/houtai/zcfgwh.vue")
      },
      {
        path: "/houtai/xwzx",
        name: "zcfg",
        component: ()=>import("@/mainhtml/houtai/xwwh.vue")
      },
      {
        path: "/houtai/xwxj",
        name: "xwxj",
        component: ()=>import("@/mainhtml/houtai/xwxj.vue")
      },
      {
        path: "/houtai/zcfgedit",
        name: "zcfgedit",
        component: ()=>import("@/mainhtml/houtai/zcfgedit.vue")
      },
      {
        path: "/houtai/xwzxedit",
        name: "xwzxedit",
        component: ()=>import("@/mainhtml/houtai/xwedit.vue")
      },
      {
        path: "/houtai/bgxz",
        name: "bgxz",
        component: ()=>import("@/mainhtml/houtai/bgxzwh.vue")
      },
      {
        path: "/houtai/bgxzedit",
        name: "bgxzedit",
        component: ()=>import("@/mainhtml/houtai/bgxzedit.vue")
      },
    ]
  },
  { path: '*', redirect: '/home/index' }   /*默认跳转路由*/
]


const createRouter = () =>
    new Router({
      mode: "history",
      base: process.env.BASE_URL,
      scrollBehavior: () => ({ y: 0 }),
      routes
    });

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}


const LOGIN_PAGE_NAME = 'login'

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()
  const userId = getUserId()
  const toname=location.href
  //判断是后台页面进行登录判断
  if(toname.indexOf("houtai") != -1){
    if (!userId && !token && to.name !== LOGIN_PAGE_NAME) {
      // 未登录且要跳转的页面不是登录页
      next({
        name: LOGIN_PAGE_NAME // 跳转到登录页
      })
    } else if (!userId && !token && to.name === LOGIN_PAGE_NAME) {
      // 未登陆且要跳转的页面是登录页
      next() // 跳转
    }else if (!userId && token && to.name === LOGIN_PAGE_NAME) {
      // 已登录且要跳转的页面是登录页
      next({
        name: config.homeName // 跳转到homeName页
      })
    }else {
      next()
    }
  }else{
    next()
  }

})

export default router;
